import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
    IconHome,
    IconDeviceFloppy,
    IconPencil,
    IconCheck,
    IconX,
    IconPencilQuestion,
    IconSlash
} from '@tabler/icons-react'

const OrchestratorHeader = () => {
    const navigate = useNavigate()
    const [isEditingOrchestratorName, setEditingOrchestratorName] = useState(false)
    
    return (
        <>
            <div className="flex items-center justify-between w-full px-5 shadow-md py-2 border-b border-gray-200">
                <div className="flex items-center">
                    <button
                        title='Home'
                        className="flex items-center justify-center hover:bg-gray-300"
                        onClick={() =>
                            window.history.state && window.history.state.idx > 0 ? navigate(-1) : navigate('/', { replace: true })
                        }
                    >
                        <IconHome stroke={1.5} size='1.3rem' />
                    </button>
                    <IconSlash stroke={1.5} size='1.3rem' className="rotate-175 transition-transform duration-300 ease-in-out" />
                    {!isEditingOrchestratorName && (
                        <div className="flex items-center p">
                            <h1 className="text-xl font-semibold">
                                <strong className="text-orange-500">*</strong> Orchestrator Name
                            </h1>
                            <button
                                title='Edit Name'
                                className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-200 hover:bg-gray-300 ml-2"
                                onClick={() => setEditingOrchestratorName(true)}
                            >
                                <IconPencil stroke={1.5} size='1.3rem' />
                            </button>
                        </div>
                    )}
                    {isEditingOrchestratorName && (
                        <div className="flex items-center ">
                            <input
                                type='text'
                                className="w-1/2 p-2 border border-gray-300 rounded-md ml-2"
                            />
                            <button
                                title='Save Name'
                                className="flex items-center justify-center w-10 h-10 rounded-full bg-green-200 hover:bg-green-300 ml-2"
                            >
                                <IconCheck stroke={1.5} size='1.3rem' />
                            </button>
                            <button
                                title='Cancel'
                                className="flex items-center justify-center w-10 h-10 rounded-full bg-red-200 hover:bg-red-300 ml-2"
                                onClick={() => setEditingOrchestratorName(false)}
                            >
                                <IconX stroke={1.5} size='1.3rem' />
                            </button>
                        </div>
                    )}
                </div>

                <div className="flex items-center">
                    <button type="button" className="hover:bg-gray-200 text-gray-500 font-bold py-1 px-2 rounded-md inline-flex items-center border border-gray-200 bg-white focus:border-blue-500 focus:border-2 mr-2">
                        <IconDeviceFloppy stroke={1.5} size='1.3rem' /> Save
                    </button>
                    <button type="button" className="hover:bg-gray-200 text-gray-500 font-bold py-1 px-2 rounded-md inline-flex items-center border border-gray-200 bg-white focus:border-blue-500 focus:border-2 mr-2">
                        <IconPencilQuestion stroke={1.5} size='1.2rem' className='mr-1'/>
                        Test
                    </button>
                </div>
            </div>
        </>
    )}

export default OrchestratorHeader
